import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { StepButton } from 'components/shared/StepButton/StepButton'
import { NewCategoryButton } from './../NewCategoryButton/NewCategoryButton'
import { CompetencyCategory } from './common/CompetencyCategory/CompetencyCategory'

import {
  InterviewsCreatorHandlersContext,
  InterviewsCreatorStateContext,
} from 'components/modules/creators/TemplatesCreator/tabs/Interviews/context'
import { useContext } from 'hooks'
import { CATEGORY_PLACEMENT } from '../../../../model'

import { ChevronLeftIcon, ChevronRightIcon } from 'components/shared/Icon/model'

import styles from './CategoryDetails.module.scss'

export const CategoryDetails = () => {
  const state = useContext(InterviewsCreatorStateContext)!
  const handlers = useContext(InterviewsCreatorHandlersContext)!

  const {
    isNextCategoryDisabled,
    isNextStepDisabled,
    isPreviousCategoryDisabled,
    isPreviousStepDisabled,
  } = state
  const {
    handleChangeNextStep,
    handleChangePreviousStep,
    handleInsertCategory,
  } = handlers

  return (
    <Box align="center" className={styles.details}>
      <StepButton
        ariaLabel="previous"
        icon={ChevronLeftIcon}
        onClick={handleChangePreviousStep}
        isDisabled={isPreviousStepDisabled}
      />
      <Box className={styles.category} direction="column">
        <NewCategoryButton
          onClick={handleInsertCategory({ type: CATEGORY_PLACEMENT.PREVIOUS })}
          isDisabled={isPreviousCategoryDisabled}
        />
        <Box className={styles.content} direction="column" tagName="section">
          <CompetencyCategory />
        </Box>
        <NewCategoryButton
          onClick={handleInsertCategory({ type: CATEGORY_PLACEMENT.NEXT })}
          isDisabled={isNextCategoryDisabled}
        />
      </Box>
      <StepButton
        ariaLabel="next"
        icon={ChevronRightIcon}
        onClick={handleChangeNextStep}
        isDisabled={isNextStepDisabled}
      />
    </Box>
  )
}
